"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKitExperimentBanner = void 0;
const react_1 = require("react");
const configCat_service_1 = require("../../../../services/configCat/configCat.service");
const cycle_1 = require("../../../../utils/helpers/cycle");
var BannerType;
(function (BannerType) {
    BannerType["MENU"] = "menu";
    BannerType["HOME"] = "home";
})(BannerType || (BannerType = {}));
const useKitExperimentBanner = ({ type }) => {
    const [bannerImage, setBannerImage] = (0, react_1.useState)('');
    const [isBannerOn, setIsBannerOn] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const fetchBannerImage = () => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoading(true);
            const result = yield (0, configCat_service_1.getValueConfigCat)({
                key: 'kitsexperimentmenubanners',
                default: '',
            }).then((res) => JSON.parse(res));
            const typeParsed = type ? type : BannerType.MENU;
            const flag = result[typeParsed];
            const banner = flag === null || flag === void 0 ? void 0 : flag.bannerURL;
            const startDate = flag === null || flag === void 0 ? void 0 : flag.startDate;
            const endDate = flag === null || flag === void 0 ? void 0 : flag.endDate;
            const isExperimentPeriod = (0, cycle_1.getCyclePeriodDate)(startDate, endDate);
            setIsBannerOn(isExperimentPeriod);
            setBannerImage(banner);
            setIsLoading(false);
        });
        fetchBannerImage();
    }, []);
    return {
        isBannerOn,
        isLoading,
        bannerImage,
    };
};
exports.useKitExperimentBanner = useKitExperimentBanner;
